import { Tab } from "@headlessui/react";
import { classNames } from "../../../utils/classNames";
import Divider from "../Divider";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
type Props = {
  tabTitle: any;
  tabPanels: any;
};

const TabPanel = (props: Props) => {
  const { tabTitle, tabPanels } = props;

  return (
    <div className={tw`rounded-md bg-white mt-4 mb-4 outline-none h-full`}>
      <Tab.Group>
        <Tab.List className={tw`flex`}>
          {tabTitle?.map((elem: any) => {
            return (
              <Tab
                key={elem}
                className={({ selected }) =>
                  classNames(
                    tw`text-md capitalize p-2 px-2 first:rounded-tl-md outline-none focus:outline-none`,
                    selected
                      ? tw`bg-gray-50 shadow border-b border-0 border-primary `
                      : tw`hover:bg-gray-200 text-gray-600 hover:text-gray-700 bg-gray-200 `
                  )
                }
              >
                {elem}
              </Tab>
            );
          })}
        </Tab.List>
        <Divider />
        <Tab.Panels>
          {tabPanels?.map((elem: any, index: number) => {
            return (
              <Tab.Panel className={tw`p-2`} key={index}>
                {elem}
              </Tab.Panel>
            );
          })}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default TabPanel;
